export const EventVisual = ({ tone = 'aqua', label = 'event photo' }) => {
  const tones = {
    aqua:   { bg: 'oklch(0.94 0.05 198)',  fg: 'oklch(0.88 0.09 198)',  ink: 'oklch(0.45 0.10 200)' },
    pink:   { bg: 'oklch(0.95 0.04 350)',  fg: 'oklch(0.88 0.08 350)',  ink: 'oklch(0.48 0.12 350)' },
    purple: { bg: 'oklch(0.95 0.035 300)', fg: 'oklch(0.86 0.07 300)',  ink: 'oklch(0.45 0.12 300)' },
    yellow: { bg: 'oklch(0.97 0.05 95)',   fg: 'oklch(0.90 0.10 95)',   ink: 'oklch(0.55 0.12 80)' },
    neutral:{ bg: 'oklch(0.96 0.006 220)', fg: 'oklch(0.90 0.008 220)', ink: 'oklch(0.50 0.008 240)' },
  };
  const t = tones[tone] || tones.aqua;
  return (
    <div style={{
      position: 'relative', width: '100%', aspectRatio: '4/3',
      borderRadius: 'var(--radius)',
      background: `linear-gradient(135deg, ${t.bg}, ${t.fg})`,
      overflow: 'hidden',
      border: '1px solid var(--line-2)',
    }}>
      <div style={{
        position: 'absolute', inset: '15% 20%',
        background: `radial-gradient(ellipse at 30% 30%, ${t.fg}, transparent 70%)`,
        borderRadius: '50%',
        filter: 'blur(8px)',
      }} />
      <div style={{
        position: 'absolute', left: 14, bottom: 12,
        fontFamily: 'var(--font-mono)', fontSize: 10,
        letterSpacing: '.12em', textTransform: 'uppercase',
        color: t.ink, opacity: 0.7,
      }}>[ {label} ]</div>
    </div>
  );
};
